import ItemsPerPage from '@dc/ui-library/src/molecules/ItemsPerPage/ItemsPerPage';
import ReactDOM from 'react-dom';
import React from 'react';
import { connect, Provider } from 'react-redux';
import uiLocale from '../../../utils/UILocale.js';

export default function initItemsPerPageCount() {
  const mountEl =
        document.querySelector('[data-component="itemsPerPage"]');

  const input = document.getElementById('items-per-page-input');

  function mapStateToProps(state) {
    const itemsNumberPerPage = state.listingPage.pagination.itemsNumberPerPage;
    return {
      activeOption: itemsNumberPerPage.selectedOptionValue,
      itemsCount: itemsNumberPerPage.categoryProductCount,
      options: itemsNumberPerPage.optionList
    };
  }

  const ConnectedItemsOnPage = connect(mapStateToProps)(ItemsPerPage);

  if (mountEl) {
    ReactDOM.render(
      <Provider store={window.appState}>
        <ConnectedItemsOnPage
          showLabelStart={uiLocale.getString('component.pagination.label-show')}
          showLabelEnd={uiLocale.getString('component.pagination.label-end')}
          showLabelEndMobile={uiLocale.getString('component.pagination.label-mobile-end')}
          allLinkLabel={uiLocale.getString('component.pagination.label-all')}
          className="dc-items-per-page"
          onOptionSelected={(option) => {
            input.value = option;
            input.form.submit();
          }}
        />
      </Provider>,
      mountEl
    );
  }
}
